<template>
  <section class="form-box">
     <div class="container">
       <div class="row">
         <h2 class="urlap-title">Határidő módosítása (Opcionális)</h2>
       </div>
       <div class="row">
         <div class="ico ico-date">

           <div class=" ico">
             <Datepicker v-model="hatid" />
           </div>

           <span class="ico-right">
             <img src="/wp-content/themes/lebe-childtheme/assets/images/ico/naptar.png" alt="">
           </span>
         </div>
       </div>
       <div class="row" style="padding-top: 20px"  v-if="kategoria != 'Kérem keressen fel!'">
         Kategória: <span style="margin-left: 10px" class="big color-primary">
           {{kategoria}}
         </span>
       </div>
       <div class="row" style="padding-top: 20px" v-else>
         <div class="alert alert-warning">
           Kérem keressen fel bennünket telefonon (06209747571), vagy írjon e-mailt (<a class="color-secondary" target="_blank" href="mailto:nonstop@fnt-forditoiroda.hu ">nonstop@fnt-forditoiroda.hu </a>).
         </div>
       </div>
    </div>
  </section>
</template>
<script>
import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  props: [
    'hatarido',
    'kategoria'
  ],
  components: {
    Datepicker
  },
  data: function(){
    return {
      hatarido$: ''
    }
  },
  computed: {
    hatid: {
      get() {
        return this.hatarido
      },
      set(val) {
        this.$emit(`update:hatarido`,val)
      }
    }
  }
}

</script>
